import React, { useEffect, Fragment, useRef } from 'react';
import { Table, Tooltip, Button, Dropdown, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import styles from './monitoring_result.module.sass';
import { STATUS } from '../../../../redux/constants';
import { incrementUIRequestsCounter } from '../../../../redux/utils/websocket/incrementUIRequestsCounter';
import { useDispatch } from 'react-redux';

function ResultsHistory(props) {
  const selectedFileUUID = useRef(null);
  const dispatch = useDispatch();
  const columns = [
    {
      title: <ColumnTitle columnName="Date & Time" />,
      dataIndex: 'created',
      key: 'created',
      align: 'left',
      render: (text, record) => text?.substring(0, 19) + ' (UTC)',
    },
    {
      title: <ColumnTitle columnName="Total Results" />,
      dataIndex: 'iocs_count',
      key: 'created',
      align: 'left',
      render: (text, record) => (
        <Tooltip placement="top" title="Total results from this day">
          {text}
        </Tooltip>
      ),
    },
    {
      title: '',
      key: 'actions',
      render: (record) => (
        <div className={styles.action_buttons}>
          <Tooltip
            placement="top"
            title={getViewResultsBtnTooltipTitle(record)}
          >
            <Button type="link" disabled={isViewMonitorBtnDisabled(record)}>
              <Link
                to={getViewMonitorLink(record)}
                target="_blank"
                style={{
                  color: isViewMonitorBtnDisabled(record)
                    ? '#595959'
                    : '#3C9AE8',
                }}
              >
                View
              </Link>
            </Button>
          </Tooltip>
          <Tooltip
            placement="top"
            title={getCopyResultsBtnTooltipTitle(record)}
          >
            <Button
              type="link"
              loading={
                props?.copyFileContentStatus === STATUS.LOADING &&
                selectedFileUUID.current == record?.uuid
              }
              disabled={isDownloadResultsBtnDisabled(record)}
              style={{
                color: isDownloadResultsBtnDisabled(record)
                  ? '#595959'
                  : '#3C9AE8',
                marginLeft: '8px',
                marginRight: '8px',
              }}
              onClick={() => {
                selectedFileUUID.current = record.uuid;
                props.fileContentCopy(record?.uuid);
                incrementUIRequestsCounter();
              }}
            >
              Copy
            </Button>
          </Tooltip>
          <Tooltip
            placement="top"
            title={getDownloadResultsBtnTooltipTitle(record)}
            style={{ margin: '1px' }}
          >
            <Button
              type="link"
              loading={
                props?.downloadFileStatus === STATUS.LOADING &&
                selectedFileUUID.current == record?.uuid
              }
              disabled={isDownloadResultsBtnDisabled(record)}
              style={{
                color: isDownloadResultsBtnDisabled(record)
                  ? '#595959'
                  : '#3C9AE8',
              }}
              onClick={() => {
                selectedFileUUID.current = record.uuid;
                props.fileDownload(record?.uuid, 'csv');
                incrementUIRequestsCounter();
              }}
            >
              Download
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const getViewMonitorLink = (record) => {
    return `/explore-result?name=${
      props?.monitorQuery?.name
    }&queryType=monitoringResults&type=monitoringResults&fromMonitoring=true&resultFileUUID=${
      record?.uuid
    }&monitorName=${
      props?.monitorQuery?.name
    }&resultFileCreatedAt=${record?.created?.substring(
      0,
      19,
    )} (UTC)&resultFileIocsCount=${record?.iocs_count}`;
  };

  const isViewMonitorBtnDisabled = (record) => {
    if (!record?.iocs_count) return true;
    if (props?.monitorQuery.url?.includes('domain/search')) return true;
    return false;
  };

  const isDownloadResultsBtnDisabled = (record) => {
    if (!record?.iocs_count) return true;
    if (props?.monitorQuery.url?.includes('domain/search')) return true;
    return false;
  };

  const getDownloadResultsBtnTooltipTitle = (record) => {
    if (props?.monitorQuery.url?.includes('domain/search'))
      return 'Downloading this result is currently not supported';
    if (record?.iocs_count === 0)
      return 'This monitor has not detected any new results';
    return 'Download result';
  };

  const getViewResultsBtnTooltipTitle = (record) => {
    if (props?.monitorQuery.url?.includes('domain/search'))
      return 'Viewing this result is currently not supported';
    if (record?.iocs_count === 0)
      return 'This monitor has not detected any new results';
    return 'View result';
  };

  const getCopyResultsBtnTooltipTitle = (record) => {
    if (props?.monitorQuery.url?.includes('domain/search'))
      return 'Copying this result is currently not supported';
    if (record?.iocs_count === 0)
      return 'This monitor has not detected any new results';
    return 'Copy result';
  };

  return (
    <Fragment>
      <div id="resultHistoryTable" className={styles.feed_container}>
        <Table
          loading={props?.monitoringQueryResultHistoryStatus === STATUS.LOADING}
          columns={columns}
          dataSource={props?.monitoringQueryResultHistories}
          pagination={false}
          locale={{
            emptyText:
              props.monitoringQueryResultHistoryStatus === STATUS.LOADED ? (
                props?.monitorQuery?.is_active === true ? (
                  <div
                    style={{
                      height: '150px',
                      marginTop: '75px',
                      color: 'rgba(255, 255, 255, 0.85)',
                    }}
                  >
                    <span style={{ fontSize: '16px', fontWeight: '700' }}>
                      The monitor has not been processed yet.
                    </span>
                    <br />
                    <span>
                      Please allow one hour for the first-time processing of
                      this monitor.
                      <br />
                      Thereafter, results will be available once we detect new
                      changes
                    </span>
                  </div>
                ) : (
                  <div
                    style={{
                      height: '150px',
                      marginTop: '75px',
                      color: 'rgba(255, 255, 255, 0.85)',
                    }}
                  >
                    <span style={{ fontSize: '16px', fontWeight: '700' }}>
                      The Monitor is not active.
                    </span>
                    <br />
                    <span>
                      Your monitor is currently inactive so will not retrieve
                      any results
                    </span>
                  </div>
                )
              ) : (
                <></>
              ),
          }}
        ></Table>
      </div>
    </Fragment>
  );
}
export default ResultsHistory;
